import { Button, Grid, Typography } from "@mui/material";
import "../AppMobileXS.css";
import ButtonCeci from "./ButtonCeci";

export default function Card1() {
    return (
        <Grid container size={12} sx={{width: '70%', marginLeft: "10%", marginRight: "20%", marginTop: "150px"}}>
            <Grid item sx={{textAlign: 'left'}}>
                <div className="stile-titolo">MUOVITI MEGLIO <br/>VIVI MEGLIO!</div>
                <div style={{marginTop: '20px'}}className="stile-sottotitolo">Percorsi personalizzati per ritrovare <br/> equilibrio, benessere e salute</div>
                <ButtonCeci onClick={() => {
                        const el = document.getElementById("contatti");
                        if (el) {
                            el.scrollIntoView({ behavior: "smooth" });
                        }
                }} sx={{marginTop: "50px"}}>Fai una prova</ButtonCeci>
            </Grid>
        </Grid>
    );
}
